var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7897_29827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7422 27.1123H40.7422C41.0074 27.1123 41.2618 27.0069 41.4493 26.8194C41.6368 26.6319 41.7422 26.3775 41.7422 26.1123V17.1123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7422 14.113L32.0882 1.68101C32.2699 1.52394 32.502 1.4375 32.7422 1.4375C32.9824 1.4375 33.2145 1.52394 33.3962 1.68101L47.7422 14.113",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7422 1.1123H42.7422C43.0074 1.1123 43.2618 1.21766 43.4493 1.4052C43.6368 1.59273 43.7422 1.84709 43.7422 2.1123V6.1123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46019 17.1123H29.0242C30.2755 17.1123 31.4755 17.6094 32.3603 18.4942C33.2451 19.379 33.7422 20.579 33.7422 21.8303V42.3943C33.7422 43.6456 33.2451 44.8456 32.3603 45.7304C31.4755 46.6152 30.2755 47.1123 29.0242 47.1123H6.46219C5.21037 47.1123 4.00982 46.615 3.12464 45.7298C2.23947 44.8447 1.74219 43.6441 1.74219 42.3923V21.8303C1.74219 20.579 2.23926 19.379 3.12406 18.4942C4.00885 17.6094 5.2089 17.1123 6.46019 17.1123V17.1123Z",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7422 17.1123V46.8903",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74219 32.1123H33.7422",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73828 25.1123H12.7443",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7422 25.1123H28.7482",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7422 37.1123H28.7482",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7422 41.1123H28.7482",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 22.1123V28.1123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62109 36.9873L11.8671 41.2353",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 36.9951L7.62891 41.2371",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7897_29827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.742188 0.112305)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/Calculator.5ec02e4dfb1972562829101ef2bafb7b.svg";
export { ForwardRef as ReactComponent };